import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// Handles the Google OAuth redirect: `/<any-route>#session_id=<opaque>`.
// Exchanges the session_id with the backend, then routes to /account.
const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : '';

    if (!sessionId) {
      setError('Missing session_id in redirect.');
      return;
    }

    (async () => {
      try {
        await axios.post(
          `${API_URL}/api/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        // Clean the hash then re-check auth via /me
        window.history.replaceState({}, document.title, '/account');
        await refresh();
        navigate('/account', { replace: true });
      } catch (err) {
        setError('Sign-in failed. Please try again.');
      }
    })();
  }, [location.hash, navigate, refresh]);

  return (
    <div
      className="min-h-screen flex items-center justify-center"
      data-testid="auth-callback"
      style={{ color: 'rgba(255,255,255,0.7)' }}
    >
      {error ? (
        <div style={{ textAlign: 'center' }}>
          <p style={{ marginBottom: '1rem' }}>{error}</p>
          <a href="/login" className="text-brand-primary underline">
            Return to sign in
          </a>
        </div>
      ) : (
        <p style={{ letterSpacing: '0.2em', textTransform: 'uppercase' }}>
          Signing you in…
        </p>
      )}
    </div>
  );
};

export default AuthCallback;
